import * as React from 'react';
import AddClearbtn from './AddClearBtn';

const TopLeftCompareProduct = (props) => {

    return (
        <>
            <div className="d-flex">
                <AddClearbtn />
            </div>
        </>
    );
}

export default TopLeftCompareProduct;